module.exports = __webpack_public_path__ + "media/images/PivotEnterpriseImageBG-41240d4fad9ece5d2a67555f863eb350551c039f1dad3ce92dc301260953a0e5.jpg";